(function() {
  window.Home = window.Home || {};

  window.Home.trackDiscoveryForm = function (form) {
    FS.Analytics.trackValue('NLIDiscoveryForm:SubmitButton:clicked');

    for(var i=0; i < form.elements.length; i++){
      let el = form.elements[i];
      if(el.value) {
        HF.jsLoaded.then(() => {
          FS.Analytics.trackValue(`NLIDiscoveryForm:${el.name}:filledIn`);
        });
      }  
    }
  }

})();